import { FRONTIFY_URL } from '@shared/utils';

// Image URLs for UnderageSection
const AGE_SAFE_IMAGES = {
  GAMBLING_COMMISSION: {
    light: `${FRONTIFY_URL}U9kDGMMKbi8nFUfQYHLv.svg`,
    dark: `${FRONTIFY_URL}eULZKYLVCs6aBLDqVDGE.svg`,
  },
  GAMBLE_AWARE: {
    light: `${FRONTIFY_URL}3fy55C7656reUzf5ytvj.svg`,
    dark: `${FRONTIFY_URL}tEX2JDc1CAQR2tTB3GFX.svg`,
  },
  GAMSTOP: `${FRONTIFY_URL}5mPP869UW65xo1YDnJMU.svg`,
  NATIONAL_GAMBLING_HELPLINE: `${FRONTIFY_URL}fwbD8B8XfmyBmWexpMvj.svg`,
  TAKE_TIME_TO_THINK: {
    light: `${FRONTIFY_URL}e89b5V78wBaeKpga8WDn.svg`,
    dark: `${FRONTIFY_URL}FMyfC7N3jzzxYQRWXcVo.svg`,
  },
  GAMBLE_SAFELY: {
    light: `${FRONTIFY_URL}bcPYcbWuWR6by1bz7duy.svg`,
    dark: `${FRONTIFY_URL}Sux7s6F3RosYqrdSWn9g.svg`,
  },
  UNDERAGE_GAMBLING: {
    light: `${FRONTIFY_URL}MFC2FugXG4E2FgkdVXNq.svg`,
    dark: `${FRONTIFY_URL}3n2odZ2z12NT8JUn7kdF.svg`,
  },
  GAMBLE_ANONYMOUS: {
    light: `${FRONTIFY_URL}tYuUpL1o6NA319Pr7VaQ.svg`,
    dark: `${FRONTIFY_URL}xARPSWfbq7WEfYgVtHBu.svg`,
  },
} as const;

export { AGE_SAFE_IMAGES };
